import {
  Barbell,
  ForkKnife,
  Gear,
  House,
  type Icon,
  MoonStars,
  PersonSimpleWalk,
} from '@phosphor-icons/react';
import { type ComponentType, type LazyExoticComponent, lazy } from 'react';
import type { Route } from '@/core/router';

// Every area of the app. Each module owns src/modules/<id>/: a Page (default export,
// receives the route) and optionally a Sidebar section shown under the nav on desktop
// and in the phone drawer.

export interface PageProps {
  route: Route;
}

export interface ModuleDef {
  id: string;
  label: string;
  icon: Icon;
  page: LazyExoticComponent<ComponentType<PageProps>>;
  sidebar?: LazyExoticComponent<ComponentType>;
  group: 'main' | 'system';
  /** path that creates something new (command palette, shortcuts) */
  newPath?: string;
  newLabel?: string;
}

export const MODULES: ModuleDef[] = [
  {
    id: 'today',
    label: 'Today',
    icon: House,
    page: lazy(() => import('@/modules/today/Page')),
    group: 'main',
  },
  {
    id: 'food',
    label: 'Food',
    icon: ForkKnife,
    page: lazy(() => import('@/modules/food/Page')),
    group: 'main',
    newPath: '/food?add=1',
    newLabel: 'Log food',
  },
  {
    id: 'sleep',
    label: 'Sleep',
    icon: MoonStars,
    page: lazy(() => import('@/modules/sleep/Page')),
    group: 'main',
  },
  {
    id: 'body',
    label: 'Body',
    icon: Barbell,
    page: lazy(() => import('@/modules/body/Page')),
    group: 'main',
    newPath: '/body?add=1',
    newLabel: 'Log weight',
  },
  {
    id: 'activity',
    label: 'Activity',
    icon: PersonSimpleWalk,
    page: lazy(() => import('@/modules/activity/Page')),
    group: 'main',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: Gear,
    page: lazy(() => import('@/modules/settings/Page')),
    group: 'system',
  },
];

export const moduleById = new Map(MODULES.map((m) => [m.id, m]));

export function moduleFor(path: string): ModuleDef {
  const id = path.split(/[/?#]/).filter(Boolean)[0] ?? 'today';
  return moduleById.get(id) ?? MODULES[0]!;
}

/** Phone bottom bar (customizable in Settings → Appearance). */
export const DEFAULT_BOTTOM_NAV = ['today', 'food', 'sleep', 'body', 'activity'];
